import { render, staticRenderFns } from "./TheAnnouncekit.vue?vue&type=template&id=00678aa6&scoped=true&"
import script from "./TheAnnouncekit.vue?vue&type=script&lang=ts&"
export * from "./TheAnnouncekit.vue?vue&type=script&lang=ts&"
import style0 from "./TheAnnouncekit.vue?vue&type=style&index=0&id=00678aa6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00678aa6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsTooltip: require('/app/src/components/common/EsTooltip.vue').default})
